export const DEFAULT_APP = '/public/feature'